// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import "@babel/polyfill";
import App from './App'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import router from './router'
import FastClick from 'fastclick'
import '@ass/css/reset.css'
import '@ass/css/iconfont/iconfont.css'
import '@ass/iconfont/iconfont.css'
import QRCode from 'qrcode'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import HhtRefInput from './pub/components/baseRef/refInput.vue';
import HhtRefSelect from './pub/components/baseRef/refSelect.vue';

Vue.use(MintUI)
Vue.use(QRCode)
Vue.use(VueAxios, Axios)
Vue.use(ElementUI);

/**  注册红火台专用组件  **/
Vue.component("hht-ref-input",HhtRefInput);
Vue.component("hht-ref-select",HhtRefSelect);

document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
// (function (doc, win) {
//   var docEl = doc.documentElement,
//   resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',//orientationchange设备旋转 resize调整浏览器窗口的大小
//   recalc = function () {
//     var clientWidth = docEl.clientWidth;//设备
//     if (!clientWidth) return;
//     if ( clientWidth > 768 ) {
//       docEl.style.fontSize = (clientWidth / clientWidth) * 100 + 'px';
//     } else {
//       docEl.style.fontSize = clientWidth / 7.5 + 'px';
//     }
//   };

//   if (!doc.addEventListener) return;
//   win.addEventListener(resizeEvt, recalc, false);
//   doc.addEventListener('DOMContentLoaded', recalc, false);//火狐加载DOMContentLoaded，优先于load
//   document.addEventListener('plusready',function(){
//     window.XMLHttpRequest = plus.net.XMLHttpRequest;
//   })
// })(document, window);
/*router.beforeEach((to, from, next) => {
  const shareRouterPath = ['shareSelect', 'share', 'editor'];
  
  // 分享页面刷新返回分享页面的首页
  if (from.name === null && to.name !== 'shareSelect' && shareRouterPath.includes(to.name)) {
    let params = sessionStorage.getItem('shareReload');
    if (params) next(`/shareSelect?${params}`);
    else next('/shareSelect');
  }
  next();
})*/
router.afterEach((to, from) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
})

FastClick.attach(document.body)
FastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
}

Vue.config.productionTip = false

Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
      // 聚焦元素
      el.focus()
    }
  })


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js